import type { Environment } from '@brighthub/environment';
import {
  CARE_PLAN_ADMIN_GROUP,
  CARE_PLAN_LOWER_ENV_ADMIN_GROUP,
} from './care-plan-access.token';

/** Override permission is independent of existing Care Plan view/edit access. */
export function canOverrideOptionQualification(
  deployment: Environment['environment'],
  hasGroup: (group: string) => boolean,
): boolean {
  switch (deployment) {
    case 'dev':
    case 'stage':
      return hasGroup(CARE_PLAN_LOWER_ENV_ADMIN_GROUP);
    case 'uat':
      return (
        hasGroup(CARE_PLAN_ADMIN_GROUP) ||
        hasGroup(CARE_PLAN_LOWER_ENV_ADMIN_GROUP)
      );
    case 'prod':
      return hasGroup(CARE_PLAN_ADMIN_GROUP);
    default:
      return false;
  }
}
